import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../defaultState';
import { Iplayer } from '../../interfaces/StoreTypes';

type SetPlayerAction = {
    type: string;
    payload: boolean;
};

const playerSlice = createSlice({
    name: 'Player',
    initialState: initialState.player,
    reducers: {
        setMuteState: (state: Iplayer, action: SetPlayerAction) => {
            state.isMuted = action.payload;
        },
    },
});

export const { setMuteState } = playerSlice.actions;

export default playerSlice.reducer;
